module.exports = __webpack_public_path__ + "img/20251009.6b83a4bc.jpg";